/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React from 'react';
import $ from 'jquery';
import PropTypes from 'util/PropTypes';
import CSSTransition from 'react-transition-group/CSSTransition';

/**
 * This React component will automatically sets/unsets the 'display' property on the containing component
 * based on whether the component is hidden from view or not.
 */

const CSSHidingTransition = (props) => {
	return (
		<CSSTransition
			{...props}
			timeout={300}
			onEnter={ props.onEnter ? props.onEnter : (node) => $(node).css('display', '') }
			onExited={ props.onExited ? props.onExited : (node) => $(node).css('display', 'none') }
		/>
	);
};

CSSHidingTransition.propTypes = {
	onEnter: PropTypes.func,
	onExited: PropTypes.func
};

export default CSSHidingTransition;



// WEBPACK FOOTER //
// ./src/js/components/transition/CSSHidingTransition.js